/**
 * Return true when value is defined OR contains value
 * @param {Object} value, variable to check
 * @return {Boolean} false if variable is undefined but true if value is null
 */
function isDefined(value) {
  return typeof value !== typeof undefined || value !== undefined;
}

/**
 * Return true when value is not defined
 * Return true when value is null
 * @param {Object} value, variable to check
 * @return {Boolean} true if variable is undefined OR value is null
 */
function isNull(value) {
  return !isDefined(value) || value === null;
}

function notDefined(value) {
  return !isDefined(value);
}

function notNull(value) {
  return !isNull(value);
}

/**
 * Return true when value is defined and its type is String
 * @param {Object} value, variable to check
 * @return {Boolean} true if variable is defined AND its type is String
 */
function isString(value) {
  return isDefined(value) && typeof value === "string";
}

/**
 * Return true when value is defined and its type is Object
 * @param {Object} value, variable to check
 * @return {Boolean} true if variable is defined AND its type is Object
 */
function isObject(value) {
  if (notDefined(value)) return false;
  const type = typeof value;
  return type === "function" || type === "object";
}

/**
 * Return true when value is null or empty String/Object/Array
 * @param {Object} value, variable to check
 * @return {Boolean} true if variable is null or empty String/Object/Array
 */
function isEmpty(value) {
  if (isNull(value)) return true;
  else if (isObject(value)) {
    if (value instanceof Date) return false;
    return Object.keys(value).length === 0 && !value.innerHTML;
  } else return isDefined(value.length) && value.length === 0;
}

function isNumber(value) {
  return value !== null && value !== undefined && !isNaN(Number(value));
}

/**
 * Return value, default value or null
 * @param {Object} value, variable to check,
 * @param {Object} defaultValue, default value
 * @return {Object} value if variable exists or default value/null
 */
function getValueOrDefault(value, defaultValue) {
  if (defaultValue === undefined) {
    defaultValue = null;
  }
  return isDefined(value) ? value : defaultValue;
}

export {
  isDefined,
  notDefined,
  isNull,
  notNull,
  isString,
  isObject,
  isEmpty,
  isNumber,
  getValueOrDefault,
};
